import { render, staticRenderFns } from "./AgendaTable.vue?vue&type=template&id=6dc3d9c5"
import script from "./AgendaTable.vue?vue&type=script&lang=js"
export * from "./AgendaTable.vue?vue&type=script&lang=js"
import style0 from "./AgendaTable.vue?vue&type=style&index=0&id=6dc3d9c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports